import Form from 'components/form/Form';
import { bindMethod } from 'helpers/bind';
export default class NewsletterForm extends Form {
    bindEvents(add) {
        super.bindEvents(add);
        const method = bindMethod(add);
        this.inputs[0][method]('input', this.onEmailChange);
    }
    onEmailChange = (e) => {
        const target = e.currentTarget;
        this.refs.formSubmit.classList.toggle('visible', target.value.length > 0);
    };
}
